// extracted by mini-css-extract-plugin
export default {"ad":"HomePage_ad__OzLuy"};